import { render, staticRenderFns } from "./ProjetoAnexosExcluir.vue?vue&type=template&id=10c5428c"
import script from "./ProjetoAnexosExcluir.vue?vue&type=script&lang=js"
export * from "./ProjetoAnexosExcluir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports